// extracted by mini-css-extract-plugin
export default {"Container":"PageLayout_Container__7SjEO","CardContainer":"PageLayout_CardContainer__G+xKv","Section":"PageLayout_Section__H2aKw"};